export const TRANSLATIONS_JP_DASHBOARD_AND_KNOWLEDGE = {
  "dashboard.title": "ダッシュボード",
  "dashboard.documents": "ドキュメント",
  "dashboard.credits": "クレジット",
  "dashboard.users": "アクティブユーザー",
  "dashboard.questions": "質問",
  "dashboard.embeddings": "埋め込み",
  "dashboard.status": "システムステータス",
  "dashboard.widget.plan_usage": "プラン使用量",
  "dashboard.widget.csv_stats": "CSV統計",
  "dashboard.widget.csv_stats.uploaded": "アップロードされたCSVファイル",
  "dashboard.widget.csv_stats.queries": "実行されたクエリ",
  "dashboard.widget.documents_stats": "ドキュメント統計",
  "dashboard.widget.documents_stats.count": "アップロードされたドキュメント",
  "dashboard.widget.documents_stats.duplicates": "重複",
  "dashboard.widget.documents_stats.this_month": "今月",
  "dashboard.widget.email_stats": "メール統計",
  "dashboard.widget.email_stats.sent": "処理済みメール",
  "dashboard.widget.email_stats.received": "タスクに変換されたメール",
  "dashboard.widget.tokens_breakdown": "トークン内訳",
  "dashboard.widget.tokens_breakdown.input": "使用トークン（埋め込み）",
  "dashboard.widget.tokens_breakdown.output": "使用トークン（RAG）",
  "dashboard.widget.tokens_breakdown.exceeded": "トークン上限超過",
  "dashboard.widget.rag_queries": "RAGクエリ",
  "dashboard.widget.rag_queries.count": "RAGクエリ",
  "dashboard.widget.rag_queries.top_users": "トップユーザー：",
  "dashboard.widget.plan_usage.used": "使用済み",
  "dashboard.widget.plan_usage.remaining": "残り",
  "dashboard.widget.plan_usage.total": "合計",
  "dashboard.widget.plan_usage.exceeded": "プラン上限超過",
  "dashboard.widget.user_activity": "ユーザーアクティビティ",
  "dashboard.widget.inactive_users": "非アクティブユーザー",
  "dashboard.widget.user_activity.active": "アクティブユーザー",
  "dashboard.widget.user_activity.inactive": "非アクティブユーザー",
  "dashboard.widget.inactive_users.count": "非アクティブユーザー",
  "dashboard.loading": "読み込み中...",
  "dashboard.context_menu.add_widget": "ウィジェットを追加",
  "dashboard.context_menu.remove_widget": "ウィジェットを削除",
  "dashboard.context_menu.title": "利用可能なウィジェット",
  "dashboard.context_menu.group.others": "その他",
  "dashboard.context_menu.widget.csv": "CSV",
  "dashboard.context_menu.widget.consultas_rag": "RAGクエリ",
  "dashboard.context_menu.widget.tokens": "トークン",
  "dashboard.context_menu.widget.emails": "メール",
  "dashboard.context_menu.widget.documentos": "ドキュメント",
  "dashboard.context_menu.widget.usuarios_inactivos": "非アクティブユーザー",
  "dashboard.empty": "右クリックでウィジェットを追加できます。",
  "dashboard.widget.title.plan_usage": "プラン使用量",
  "dashboard.widget.title.csv_stats": "CSV統計",
  "dashboard.widget.title.documents_stats": "ドキュメント統計",
  "dashboard.widget.title.email_stats": "メール統計",
  "dashboard.widget.title.tokens_breakdown": "トークン内訳",
  "dashboard.widget.title.rag_queries": "RAGクエリ",
  "dashboard.widget.title.user_activity": "ユーザーアクティビティ",
  "dashboard.widget.title.inactive_users": "非アクティブユーザー",
  "dashboard.context_menu.widget.plan_usage": "プラン使用量",
  "dashboard.context_menu.widget.csv_stats": "CSV統計",
  "dashboard.context_menu.widget.documents_stats": "ドキュメント統計",
  "dashboard.context_menu.widget.email_stats": "メール統計",
  "dashboard.context_menu.widget.tokens_breakdown": "トークン内訳",
  "dashboard.context_menu.widget.rag_queries": "RAGクエリ",
  "dashboard.context_menu.widget.user_activity": "ユーザーアクティビティ",
  "dashboard.context_menu.widget.inactive_users": "非アクティブユーザー",
  "dashboard.widget.user_activity.last_active": "最終アクティブ",
  "dashboard.widget.user_activity.user": "ユーザー",
  "dashboard.active_users_this_month": "今月のアクティブユーザー：",
  "dashboard.active_users_today": "今日のアクティブユーザー",
  "dashboard.name": "名前",
  "dashboard.last_login": "最終ログイン",
  "dashboard.last_activity": "最終アクティビティ",
  "dashboard.inactive_users_this_month": "今月の非アクティブユーザー：",
  "dashboard.days_without_activity": "日間アクティビティなし",
  "dashboard.no_inactive_users": "今月の非アクティブユーザーはいません。",
  "dashboard.questions_today": "本日の質問",
  "dashboard.system_status": "システムステータス",
  "dashboard.action": "アクション",
  "dashboard.context_menu.no_widgets": "追加できるウィジェットがありません",
  "changes.title": "バージョン間の変更",
  "changes.empty": "検出された変更はありません。",
  "changes.filter.allSeverities": "すべての重大度",
  "changes.filter.allStatuses": "すべての状態",
  "changes.general.loading": "読み込み中...",
  "changes.general.retry": "再試行",
  "changes.error.message": "変更を読み込めませんでした。",
  "changes.evidence.before": "変更前",
  "changes.evidence.after": "変更後",
  "changes.action.confirm": "確認",
  "changes.action.needsReview": "要確認",
  "changes.action.dismiss": "却下",
  "changes.action.dismissReason": "理由（任意）",
  "changes.severity.informational": "情報",
  "changes.severity.low": "低",
  "changes.severity.medium": "中",
  "changes.severity.high": "高",
  "changes.severity.critical": "重大",
  "changes.status.detected": "検出",
  "changes.status.needs_review": "要確認",
  "changes.status.confirmed": "確認済み",
  "changes.status.dismissed": "却下",
  "changes.status.superseded": "置換済み",
  "changes.category.legal": "法務",
  "changes.category.financial": "財務",
  "changes.category.operational": "業務",
  "changes.category.compliance": "コンプライアンス",
  "changes.category.commercial": "商業",
  "changes.category.technical": "技術",
  "changes.category.human_resources": "人事",
  "changes.category.security": "セキュリティ",
  "changes.category.general": "一般",
  "alerts.title": "ナレッジアラート",
  "alerts.empty": "アクティブなアラートはありません。",
  "alerts.filter.allSeverities": "すべての重大度",
  "alerts.filter.allStatuses": "すべてのステータス",
  "alerts.filter.allSources": "すべてのソース",
  "alerts.general.loading": "読み込み中...",
  "alerts.general.retry": "再試行",
  "alerts.error.message": "アラートを読み込めませんでした。",
  "alerts.severity.informational": "情報",
  "alerts.severity.low": "低",
  "alerts.severity.medium": "中",
  "alerts.severity.high": "高",
  "alerts.severity.critical": "重大",
  "alerts.status.detected": "検出済み",
  "alerts.status.acknowledged": "確認済み",
  "alerts.status.snoozed": "スヌーズ",
  "alerts.status.resolved": "解決済み",
  "alerts.status.dismissed": "却下",
  "alerts.status.expired": "期限切れ",
  "alerts.source.expiration": "有効期限",
  "alerts.source.change": "変更",
  "alerts.refs.title": "参照元",
  "alerts.refs.open": "参照元を開く",
  "alerts.action.acknowledge": "確認",
  "alerts.action.snooze": "スヌーズ",
  "alerts.action.snoozeDays": "日数",
  "alerts.action.resolve": "解決",
  "alerts.action.dismiss": "却下",
  "alerts.action.dismissReason": "理由（任意）",
  "alerts.action.openSource": "参照元を表示",
  "dashboard.knowledge.title": "ナレッジダッシュボード",
  "dashboard.knowledge.loading": "読み込み中...",
  "dashboard.knowledge.error": "ダッシュボードを読み込めませんでした。",
  "dashboard.knowledge.retry": "再試行",
  "dashboard.knowledge.placeholder": "現在データはありません。",
  "dashboard.knowledge.changesBySeverity": "重大度別の変更",
  "dashboard.knowledge.changesByCategory": "カテゴリ別の変更",
  "dashboard.knowledge.expirationsByHorizon": "期間別の有効期限",
  "dashboard.knowledge.alertsByStatus": "ステータス別のアラート",
  "knowledge.title": "ナレッジ",
  "knowledge.tabs.entities": "エンティティ",
  "knowledge.tabs.expirations": "期限",
  "knowledge.loading": "読み込み中…",
  "knowledge.retry": "再試行",
  "knowledge.entities.subtitle": "ドキュメントから検出されたエンティティ。",
  "knowledge.entities.searchPlaceholder": "名前またはエイリアスで検索…",
  "knowledge.entities.search": "検索",
  "knowledge.entities.sources": "ソース",
  "knowledge.entities.empty": "表示するエンティティがありません。",
  "knowledge.entities.error": "エンティティを読み込めませんでした。",
  "knowledge.timeline.title": "タイムライン",
  "knowledge.timeline.empty": "このエンティティに表示できるイベントがありません。",
  "knowledge.timeline.error": "タイムラインを読み込めませんでした。",
  "knowledge.expirations.subtitle": "証拠付きで検出された今後の期限。",
  "knowledge.expirations.evidence": "証拠",
  "knowledge.expirations.dismiss": "却下",
  "knowledge.expirations.dismissed": "期限を却下しました。",
  "knowledge.expirations.dismissError": "期限を却下できませんでした。",
  "knowledge.expirations.empty": "今後の期限はありません。",
  "knowledge.expirations.error": "期限を読み込めませんでした。",
  "knowledge.type.cliente": "顧客",
  "knowledge.type.proveedor": "サプライヤー",
  "knowledge.type.contrato": "契約",
  "knowledge.type.politica": "ポリシー",
  "knowledge.type.area": "部門",
  "knowledge.type.riesgo": "リスク",
};
